import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import styles from "./KeywordInput.module.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass, faXmark } from '@fortawesome/free-solid-svg-icons';

const KeywordInput = ({ onChange, resetFlag }) => {
  const { t } = useTranslation();
  const [val, setVal] = useState("");

  useEffect(() => {
    setVal("");
  }, [resetFlag]);

  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    const validValue = inputValue.trim();
    setVal(validValue);
    onChange(validValue);
  };

  const handleReset = () => {
    setVal("");
    onChange("");
  };

  return (
    <div className={styles.searchBox}>
      <span className={styles.searchIcon}>
        <FontAwesomeIcon icon={faMagnifyingGlass} />
      </span>
      <input
        id="search-box"
        type="text"
        value={val}
        className="form-control search-box"
        placeholder={t("form.keyword")}
        onChange={handleInputChange}
      />
      {val && (
        <button className={styles.resetButton} onClick={handleReset}>
          <FontAwesomeIcon icon={faXmark} className={styles.searchIcon} />
        </button>
      )}
    </div>
  );
};

export default KeywordInput;
